import { createContext, useContext } from 'react'

interface MaldivesBundleContextValue {
  bundleFilters?: App.OfferListFilters
  isBundleMode: boolean
}

const MaldivesBundleContext = createContext<MaldivesBundleContextValue>({
  isBundleMode: false,
})

export const MaldivesBundleProvider = MaldivesBundleContext.Provider

export function useMaldivesBundleContext(): MaldivesBundleContextValue {
  return useContext(MaldivesBundleContext)
}
